import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SalaryModel } from './salary.model';
import { SalaryService } from './salary.service';
import { ActualSelected } from '../../../shared/utils';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { SalaryClassificationService } from './salary-classification.service';
import { PayrollService } from '../../../modules_v2/expense/payroll/services/payroll.service';

@Component({
    selector: 'convfact-salary',
    templateUrl: './salary.component.html',
    styleUrls: ['./salary.component.css'],
    standalone: false
})

export class SalaryComponent implements OnInit {
    salary = new SalaryModel;
    errors = {};

    submit(): void { }

    constructor(
        private salaryService: SalaryService,
        private route: ActivatedRoute,
        private router: Router,
        private salaryClassificationService: SalaryClassificationService,
        private payrollService: PayrollService,
        public snackBar: MatSnackBar
    ) { }

    private saveClasificadorIfNeeded(salaryUid: string | null, subpartida: string): void {
        if (!subpartida || !salaryUid) return;
        this.salaryClassificationService.setClassification(salaryUid, subpartida);
    }

    // Sube el PDF adjuntado en el formulario (opcional) una vez existe el uid de la nómina.
    // No bloquea el guardado ni la navegación si falla: se puede reintentar desde el listado.
    private uploadFileIfNeeded(salaryUid: string | null, file: File | null): Promise<void> {
        if (!file) return Promise.resolve();
        if (!salaryUid) {
            this.displayInfo('La nómina se guardó, pero no se pudo subir el PDF. Puedes adjuntarlo después desde el listado.');
            return Promise.resolve();
        }
        return this.payrollService.uploadFile(salaryUid, file)
            .then(() => { })
            .catch(() => {
                this.displayInfo('La nómina se guardó, pero no se pudo subir el PDF. Puedes adjuntarlo después desde el listado.');
            });
    }

    saveData = function (payload: { salary: SalaryModel, file: File | null }) {
        const salary = payload.salary;
        const file = payload.file;
        salary.fiscalYear = parseInt(ActualSelected.yearSelected);
        const clasificadorSubpartida = salary.clasificadorSubpartida;

        if (salary.uid == null) {
            this.salaryService.addData(salary)
                .then(createdUid => {
                    this.saveClasificadorIfNeeded(createdUid, clasificadorSubpartida);
                    return this.uploadFileIfNeeded(createdUid, file);
                }).then(() => {
                    this.returnToIndex();
                }).catch(errors => {
                    if (errors && errors.error && errors.error.message) {
                        this.displayInfo(errors.error.message);
                    } else {
                        this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
                    }
                })

        } else {
            this.salaryService.editData(salary.uid, salary)
                .then(savedSalary => {
                    this.salary = savedSalary;
                    this.saveClasificadorIfNeeded(savedSalary.uid, clasificadorSubpartida);
                    return this.uploadFileIfNeeded(savedSalary.uid, file);
                }).then(() => {
                    this.returnToIndex();
                }).catch(errors => {
                    if (errors && errors.error && errors.error.message) {
                        this.displayInfo(errors.error.message);
                    } else {
                        this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
                    }
                })
        }
    }

    displayInfo(response: string): void {
        const options = new MatSnackBarConfig();
        const self = this;
        options.duration = 10500;
        this.snackBar.open(response, '', options);
    }

    ngOnInit() {
        const temp = this.route.params['_value'];
        const uid = temp['salaryUid'];
        if (uid != null) {
            this.salaryService.loadData(uid).then(salary => {
                this.salary = salary;

                this.salaryClassificationService.getClassification(uid).then(classification => {
                    if (classification) {
                        this.salary.clasificadorSubpartida = classification.subpartida;
                    }
                });
            });
        }
    }

    returnToIndex = function () {
        this.router.navigate(['/expense/salary']);
    }

}
